import './ErrorState.css';

/**
 * Reusable error state component
 * @param {string} message - Error message to display
 * @param {Function} onRetry - Retry callback function (optional)
 * @param {string} retryText - Custom retry button text (optional)
 * @param {string} className - Additional CSS class (optional)
 */
function ErrorState({ 
  message = 'Si è verificato un errore. Riprova più tardi.', 
  onRetry, 
  retryText = 'Riprova',
  className = ''
}) {
  return (
    <div className={`error-state ${className}`}>
      <div className="error-icon">
        <i className="fa-solid fa-circle-exclamation"></i>
      </div>
      <p className="error-message">{message}</p>
      {onRetry && (
        <button onClick={onRetry} className="error-retry-btn">
          {retryText}
        </button>
      )}
    </div>
  );
}

export default ErrorState;
